import { Component, inject, output } from '@angular/core'
import { AuthStateService } from '@baboor/baboor-auth'

@Component({
    selector: 'app-header-admin',
    standalone: true,
    imports: [],
    templateUrl: './header-admin.component.html',
    styleUrl: './header-admin.component.scss',
})
export class HeaderAdminComponent {
    private authStateService = inject(AuthStateService)

    /** Opens/closes the mobile sidebar drawer (handled by layout-admin). */
    readonly sidebarToggle = output<void>()

    logout() {
        this.authStateService.logout()
    }
}
